var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 34,
    viewBox: "0 0 27 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8569 0.214844C10.4198 0.218899 7.12462 1.58608 4.69422 4.01647C2.26382 6.44687 0.896647 9.74203 0.892592 13.1791C0.888475 15.9879 1.80596 18.7205 3.50431 20.9577C3.50431 20.9577 3.85788 21.4232 3.91563 21.4904L13.8569 33.2148L23.8028 21.4845C23.8547 21.4221 24.2094 20.9577 24.2094 20.9577L24.2106 20.9542C25.9081 18.718 26.8252 15.9866 26.8212 13.1791C26.8171 9.74203 25.4499 6.44687 23.0195 4.01647C20.5891 1.58608 17.294 0.218899 13.8569 0.214844ZM13.8569 17.8934C12.9245 17.8934 12.013 17.6169 11.2378 17.0989C10.4625 16.5809 9.85826 15.8446 9.50145 14.9832C9.14463 14.1218 9.05127 13.1739 9.23318 12.2594C9.41508 11.3449 9.86407 10.5049 10.5234 9.84563C11.1827 9.18632 12.0227 8.73733 12.9372 8.55543C13.8516 8.37353 14.7995 8.46688 15.661 8.8237C16.5224 9.18051 17.2586 9.78475 17.7767 10.56C18.2947 11.3353 18.5712 12.2467 18.5712 13.1791C18.5696 14.429 18.0724 15.6271 17.1887 16.5109C16.3049 17.3947 15.1067 17.8919 13.8569 17.8934Z",
    fill: "#C31A7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationI);
export default __webpack_public_path__ + "static/media/locationI.3b1246a77e7a381622b5d47b0d8c494c.svg";
export { ForwardRef as ReactComponent };